import 'moment/locale/fr';
import React, {useState} from 'react';
import {DesktopDatePicker} from "@mui/x-date-pickers/DesktopDatePicker";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {LocalizationProvider} from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";
import frLocale from 'date-fns/locale/fr';

const MyDatePicker = (props) => {
  const {label, type, trueValue, setTrueValue, indice, name} = props;

  const [date, setDate] = useState(trueValue ? trueValue : null)

  return <LocalizationProvider dateAdapter={AdapterDateFns} locale={frLocale}>
    <DesktopDatePicker
      label={label}
      value={date}
      onChange={(newDate) => {
        setTrueValue(indice, name, newDate);
        setDate(newDate)
      }}
      renderInput={(params) => <TextField {...params} />}
      readOnly={type === false}
      clearable
      clearText="Effacer"
    />
  </LocalizationProvider>;

};


export default MyDatePicker;
